<template>
    <div class="containerLogin">
        <div class="left">
            <div class="headerLogin">
            <h2 class="animation a1">{{ i18n.$t('WebsiteName')}}</h2>
            <h4 class="animation a2">{{ i18n.$t('LoginTip')}}</h4>
            </div>
            <div class="form">
                <input v-model="LoginUsername" type="email" class="form-field animation a3" :placeholder="i18n.$t('LoginUsername')">
                <input v-model="LoginPassword" type="password" class="form-field animation a4" :placeholder="i18n.$t('LoginPasscode')">
                <!-- <p class="animation a5"><a href="#">忘记密码</a></p> -->
                <button class="animation a6" @click="login()">{{ i18n.$t('LoginButton')}}</button>
            </div>
        </div>
        <div class="right"></div>
    </div>
</template>

<script>
import { useI18n } from "@/i18nPlugin";
import { loginData } from '../api/index';
// import axios from 'axios';
// import qs from 'qs';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.transformRequest = [function (data) {
//     let src = ''
//     for (let item in data) {
//       src += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
//     }
//     return src
// }]
export default {
    setup() {
      const i18n = useI18n();
      return { i18n };
    },
    data() {
        return {
            LoginUsername: "",
            LoginPassword: "",
        }
    },
    mounted(){
        window.addEventListener('keydown',this.keyDown);
    },
    methods: {
        login() {
            const LoginFormData = {
                username: this.LoginUsername,
                password: this.LoginPassword,
            }
            loginData (LoginFormData).then(res => {
                if (res.token) {
                    this.$message.success('欢迎登陆售后工具系统');
                    const now = new Date()
                    const expirationDate = new Date(now.getTime() + 36000 * 1000)
                    localStorage.setItem("userName_ats",res.username);
                    localStorage.setItem("userToken",res.token);
                    localStorage.setItem("Group",res.role);
                    localStorage.setItem("isLogin",true);
                    localStorage.setItem('expirationDate', expirationDate)
                    this.$router.push({path:'/ATS'});
                }else {
                    this.$message.warning('请输入正确的用户名和密码');
                }
            }).catch(error => {
                console.log(error)
                this.$message.warning('请输入正确的用户名和密码');
            });
            // axios({
            //     url: "https://tools.transsion.com/toolstation/login",
            //     method: "post",
            //     data: qs.stringify(LoginFormData),
            //     headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded'
            //     }
            // }).then(res => {
            //     console.log(res)
            //     if (res.data.token) {
            //         this.$message.success('欢迎登陆售后工具系统');
            //         const now = new Date()
            //         const expirationDate = new Date(now.getTime() + 36000 * 1000)
            //         localStorage.setItem("userName_ats",res.data.username);
            //         localStorage.setItem("userToken",res.data.token);
            //         localStorage.setItem("Group",res.data.role);
            //         localStorage.setItem("isLogin",true);
            //         localStorage.setItem('expirationDate', expirationDate)
            //         this.$router.push({path:'/ATS'});
            //     }else {
            //         this.$message.warning('请输入正确的用户名和密码');
            //     }
            // }).catch(error => {
            //     console.log(error)
            //     this.$message.warning('请输入正确的用户名和密码');
            // });
        },
        keyDown(e){
            if(e.keyCode == 13 || e.keyCode ==100){
                this.login();
            }
        }
    },
    unmounted(){
        window.removeEventListener('keydown',this.keyDown,false);
    }
}
</script>

<style lang="less" scoped>    
    * {
        box-sizing: border-box;
    }

    body {
        font-family: 'Rubik', sans-serif;
        margin:0;
        padding:0;
    }

    .containerLogin {
        display: flex;
        height: 100vh;
    }

    .left {
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: center;
        -webkit-animation-name: left;
                animation-name: left;
        -webkit-animation-duration: 1s;
                animation-duration: 1s;
        -webkit-animation-fill-mode: both;
                animation-fill-mode: both;
        -webkit-animation-delay: 1s;
                animation-delay: 1s;
    }

    .right {
        flex: 1;
        background-color: black;
        transition: 1s;
        background-image: url(../assets/bg.png);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .headerLogin > h2 {
        margin: 0;
        color: #4f46a5;
    }

    .headerLogin > h4 {
        margin-top: 10px;
        font-weight: normal;
        font-size: 15px;
        color: rgba(0, 0, 0, 0.4);
    }

    .form {
        max-width: 80%;
        display: flex;
        flex-direction: column;
    }

    .form > p {
        text-align: right;
    }

    .form > p > a {
        color: #000;
        font-size: 14px;
    }

    .form-field {
        height: 46px;
        padding: 0 16px;
        border: 2px solid #ddd;
        border-radius: 4px;
        font-family: 'Rubik', sans-serif;
        outline: 0;
        transition: .2s;
        margin-top: 20px;
    }

    .form-field:focus {
        border-color: #0f7ef1;
    }

    .form > button {
        padding: 12px 10px;
        border: 0;
        background: linear-gradient(to right, #de48b5 0%, #0097ff 100%);
        border-radius: 3px;
        margin-top: 10px;
        color: #fff;
        letter-spacing: 1px;
        font-family: 'Rubik', sans-serif;
        cursor:pointer;
    }

    .animation {
        -webkit-animation-name: move;
                animation-name: move;
        -webkit-animation-duration: .4s;
                animation-duration: .4s;
        -webkit-animation-fill-mode: both;
                animation-fill-mode: both;
        -webkit-animation-delay: 2s;
                animation-delay: 2s;
    }

    .a1 {
        -webkit-animation-delay: 2s;
                animation-delay: 2s;
    }

    .a2 {
        -webkit-animation-delay: 2.1s;
                animation-delay: 2.1s;
    }

    .a3 {
        -webkit-animation-delay: 2.2s;
                animation-delay: 2.2s;
    }

    .a4 {
        -webkit-animation-delay: 2.3s;
                animation-delay: 2.3s;
    }

    .a5 {
        -webkit-animation-delay: 2.4s;
                animation-delay: 2.4s;
    }

    .a6 {
        -webkit-animation-delay: 2.5s;
                animation-delay: 2.5s;
    }

    @-webkit-keyframes move {
        0% {
            opacity: 0;
            visibility: hidden;
            -webkit-transform: translateY(-40px);
                    transform: translateY(-40px);
        }
        100% {
            opacity: 1;
            visibility: visible;
            -webkit-transform: translateY(0);
                    transform: translateY(0);
        }
    }

    @keyframes move {
        0% {
            opacity: 0;
            visibility: hidden;
            -webkit-transform: translateY(-40px);
                    transform: translateY(-40px);
        }
        100% {
            opacity: 1;
            visibility: visible;
            -webkit-transform: translateY(0);
                    transform: translateY(0);
        }
    }
    @-webkit-keyframes left {
        0% {
            opacity: 0;
            width: 0;
        }
        100% {
            opacity: 1;
            padding: 20px 40px;
            width: 440px;
        }
    }
    @keyframes left {
        0% {
            opacity: 0;
            width: 0;
        }
        100% {
            opacity: 1;
            padding: 20px 40px;
            width: 440px;
        }
    }
</style>